import React from 'react';

const Contact = () => {
    return (
        <div>
            <section class="text-gray-600 body-font lg:mt-5 mt-12 relative background shadow" id='contacts'>
           
                <div class="container px-5 lg:py-24 py-5 mx-auto ">
                    <div class="flex flex-col text-center w-full mb-12">
                        <h1 class="lg:text-5xl text-3xl font-medium gradient mb-8 ">Do you Want to build new Staff<br/> Knock me in Linkedin</h1>
                        <div class="flex justify-center">
                  <button class="inline-flex text-white border-outline border border-0 py-2 px-6 focus:outline hover:bg-cyan-400 rounded text-lg"><a className='text-white' href='https://www.linkedin.com/in/foyjur-rahman-164201112/' target="_blank" rel='noopener noreferrer'>Linkedin</a></button>
                </div>
                    </div>
                 
                </div>
            </section>
        </div>
    );
};

export default Contact;